module.exports = __webpack_public_path__ + "img/image19248.e8e4a6c2.png";